export default {
    "es-mx": require('./es_MX.ts')
}